module.exports = __webpack_public_path__ + "static/img/6.76e108a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/6.png
// module id = nhdl
// module chunks = 12